import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import { ExportTable } from '../../../../store/action/export/Export';
import TableHeaderComponent from '../../components/tableHeaderComponent';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilterPage,
	setSelectedInputValue,
} from '../../../../store/action/advanceFilter';
import advanceFilterIcon from '../../../../assets/image/advanceFilter_white.svg';
import clearAllFilter from '../../../../assets/image/clearAllFilter.svg';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import AdvanceFilter from '../../../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../../../component/Filter/advanceFilterOptions';
import AdvanceFilterSelectInput from '../../../../component/Filter/AdvanceFilterSelectInput';
import { getFiltersParams } from '../../../../helper';
import Pagination from '../../../../component/pagination';
import Table from '../../../../component/table/Table';
import PageLoader from '../../../../component/PageLoader';
import UseCreditNote from './hooks/useCreditNote';
import { hasPermission } from '../../../../utils/controller';
import Button from '../../../../component/ui/Button';
import DataNotFound from '../../../components/dataNotFound';
import { Plus } from 'lucide-react';

const SalesCreditNote = () => {
	const {
		user,
		creditNote,
		creditNoteParams,
		onRowClick,
		isLoading,
		isLoader,
		bulkAction,
		navigate,
		suburl,
		setBulkAction,
		deselectRows,
		FilterDatalist,
		dispatch,
		headerDropDown,
		setHeaderDropDown,
		isAdvanceFilterApplied,
		setIsAdvanceFilterOpen,
		sortDataList,
		sortDirection,
		advanceFilterPage,
		advanceFilterPageSize,
		advanceFilterTotalPages,
		handleOnFocusSelectedFilterInput,
		handleApplyFilters,
		searchSelectedInputItems,
		isAdvanceFilterOpen,
		selectedInputs,
		handleDeselectAll,
		handlePageChange,
		setCreditNoteParams,
		handlePrintAndDownloadPdf,
	} = UseCreditNote();
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const exportTableData = (param) => {
		ExportTable(param);
	};

	const creditNoteTableColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 120,
			maxWidth: 120,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'date' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								DATE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.date]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'CREDIT NOTE #',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			maxWidth: 180,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'credit_note_number' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								CREDIT NOTE #
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.credit_note_number]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'CUSTOMER NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'customer_name' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								CUSTOMER NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.customer_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 100,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'status' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								STATUS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.status]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'TYPE',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 200,
			flex: 1,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'credit_note_type' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								TYPE
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.credit_note_type]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'AMOUNT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 150,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'total_credit_amount' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								AMOUNT
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.total_credit_amount]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'CREDIT APPLIED',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 160,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'credit_applied' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								CREDIT APPLIED
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.credit_applied]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'AVAILABLE CREDIT',
			headerClass: 'HeaderBg right-align',
			suppressSizeToFit: true,
			minWidth: 160,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}
						onClick={() => sortDataList({ order_by: 'asc', sort_by: 'available_credit' })}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								AVAILABLE CREDIT
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.available_credit]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	return (
		<div>
			<TableHeaderComponent
				bulkAction={bulkAction}
				createButton={{
					disabled: !hasPermission('sales.credit_notes.create', user?.role?.role_permissions),
					buttonName: 'Create New Credit Note',
					handler: () => navigate(`/user/${suburl}/sales/credit-note-create`),
				}}
				closeButton={{
					showCloseButton: true,
					handler: () => {
						setBulkAction(false);
						setBulkAction([]);
						deselectRows && deselectRows();
					},
				}}
				buttons={[
					{
						id: 1,
						className: 'btn-gray',
						disabled: isLoader
							? true
							: !hasPermission(
									'sales.credit_notes.download_print_pdf',
									user?.role?.role_permissions,
								),
						button: 'Print',
						loader: isLoader,
						handler: () => {
							handlePrintAndDownloadPdf('', 'print', true);
						},
					},
					{
						id: 2,
						disabled: true,
						className: 'btn-gray',
						button: 'Delete',
						handler: () => {},
					},
				]}
				dropdownButton={
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							{/* <li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Excess Payment')}
								>
									Excess Payment
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Damaged / Return')}
								>
									Damaged / Return
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Advance Payment')}
								>
									Advance Payment
								</a>
							</li> */}
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Open')}
								>
									Open
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => FilterDatalist('Close')}
								>
									Close
								</a>
							</li>
						</ul>
					</div>
				}
				advanceFilterButton={
					isAdvanceFilterApplied ? (
						<div>
							<button
								onClick={() => {
									dispatch(clearAdvanceFilter());
									setHeaderDropDown('All Credit Note');
								}}
								style={{
									background: 'transparent',
									color: '#FF0000',
									fontSize: '14px',
									cursor: 'pointer',
									fontWeight: '600',
									lineHeight: '24px',
								}}
							>
								<img
									src={clearAllFilter}
									alt=""
									style={{ width: '18px', height: '18px', marginRight: '8px' }}
								/>
								Clear All Filters
							</button>
						</div>
					) : (
						<Button
							type="button"
							button="Advanced Filters"
							className="mt-0 px-4 btn-primary"
							onClick={() => setIsAdvanceFilterOpen(true)}
							icon={advanceFilterIcon}
						/>
					)
				}
				moreButton={
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<img
								src={sortbydot}
								alt=""
							/>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser"
							style={{ minWidth: '240px' }}
						>
							<li style={{ cursor: 'pointer' }}>
								<a
									className="dropdown-item"
									style={{
										display: 'flex',
										alignItems: 'center',
										fontSize: '14px',
										fontWeight: 'bold',
										justifyContent: 'space-between',
									}}
								>
									Sort By
								</a>
							</li>

							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'date' })}
								>
									Date
									<span>{sortIconMap[sortDirection?.date]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'credit_note_number' })}
								>
									Credit Note #<span>{sortIconMap[sortDirection?.credit_note_number]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'customer_name' })}
								>
									Customer Name <span>{sortIconMap[sortDirection?.customer_name]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'credit_note_type' })}
								>
									Credit Note Type
									<span>{sortIconMap[sortDirection?.credit_note_type]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'total_credit_amount' })}
								>
									Amount
									<span>{sortIconMap[sortDirection?.total_credit_amount]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'created_at' })}
								>
									Created Time
									<span>{sortIconMap[sortDirection?.created_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'updated_at' })}
								>
									Last Modified Time
									<span>{sortIconMap[sortDirection?.updated_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'balance' })}
								>
									Balance
									<span>{sortIconMap[sortDirection?.balance]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className={`dropdown-item ${!hasPermission('sales.credit_notes.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
									onClick={() => exportTableData('sales_credit_notes')}
								>
									Export Credit Note
								</a>
							</li>

							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortDataList({ order_by: 'asc', sort_by: 'id' })}
								>
									Refresh
									<span>{sortIconMap[sortDirection?.id]}</span>
								</a>
							</li>
						</ul>
					</div>
				}
			/>
			<div className="active-filter-wrapper">
				{isAdvanceFilterApplied && (
					<div className="active-filter-list">
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => {}}
								onSelect={(option) => {
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item?.key === 'status') {
										setHeaderDropDown('All Credit Note');
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div className="add-filter-btn-wrapper">
							<button
								type="button"
								className="add-filter-btn"
								onClick={() => setIsAdvanceFilterOpen(true)}
							>
								<span className="add-filter-btn__icon">
									<Plus width={15} />
								</span>
								Add Filter
							</button>
						</div>
					</div>
				)}
			</div>
			{isLoading ? (
				<PageLoader />
			) : creditNote.data.length > 0 ? (
				<div className="productTable-body">
					<Table
						row={creditNote.data}
						coloum={creditNoteTableColumn}
						className="productTable"
						onRowClick={onRowClick}
						bulkAction={bulkAction}
						action={setBulkAction}
						style={
							isAdvanceFilterApplied
								? { height: 'calc(100vh - 185px)' }
								: { height: 'calc(100vh - 148px)' }
						}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			) : (
				<DataNotFound
					title={'Manage your credit notes effortlessly!'}
					subtitle={'Smart, simple, and accurate credit tracking.'}
					descriptionTitle={'Keep your credit notes organized to streamline '}
					descriptionSubTitle={'adjustments, improve client transparency, and ensure '}
					descriptionContent={'precise bookkeeping.'}
					buttonText={'Create New Credit Note'}
					disabled={!hasPermission('sales.credit_notes.create', user?.role?.role_permissions)}
					onClick={() => navigate(`/user/${suburl}/sales/credit-note-create`)}
				/>
			)}
			{creditNote.data.length > 0 && (
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : creditNoteParams.page}
					totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : creditNote.totalPages}
					onChangePage={handlePageChange}
					pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : creditNoteParams.page_size}
					setParam={(value) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
						} else {
							setCreditNoteParams((prev) => ({
								...prev,
								page_size: value,
								page: 1,
							}));
						}
					}}
				/>
			)}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.sales_credit_note}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
		</div>
	);
};
export default SalesCreditNote;
